document.addEventListener('DOMContentLoaded', function () {
    function jcomStream() {
        new Splide("#splide-telasa", {
            autoplay: true,
            type: "loop",
            arrows: true,
            pagination: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            interval: 5000,
            speed: 1000,
            perPage: 3,
            gap: 32,
            perMove: 1,
            focus: 'center',
            padding: "10%",
            breakpoints: {
                768: {
                    perPage: 1,
                    gap: 16,
                    padding: "20%",
                },
            },
        }).mount();
    }
    if (document.querySelector("#splide-telasa")) {
        jcomStream();
    }
});
